<div class="portfolio-box">
  <h2 class="ui-headline">{{ 'yova_yellow.portfolio_box.h4' | translate }}</h2>
  <p class="ui-numbers primary">{{ femaleLeadership }}</p>
  <p>{{ 'yova_yellow.portfolio_box.p' | translate }}</p>
</div>
